module.exports = __webpack_public_path__ + "fonts/barlow-v5-latin-600.e2663d8.woff2";